import React from 'react';
import background from '../../assets/temperature.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoTemperaturerise extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Temperature Rise"
        paragraph="Annual average temperature over the contiguous United States has increased by 1.2°F (0.7°C) over the last few decades and by 1.8°F (1.0°C) relative to the beginning of the last century."
        background={background}
     />
  
  );
 }
}   

export default InfoTemperaturerise;